export default {
  chip: {
    marginTop: '8px',
    marginLeft: '8px',
    cursor: 'pointer',
  },
  chipSelected: {
    marginTop: '8px',
    marginLeft: '8px',
    cursor: 'auto',
  },
  dialogBody: {
    backgroundColor: 'rgb(240, 240, 240)',
    boxSizing: 'border-box',
    borderTop: '1px solid grey',
    borderLeft: '1px solid grey',
    borderRight: '1px solid grey',
    borderRadius: '2px 2px 0 0',
  },
  dialogActions: {
    backgroundColor: 'rgb(240, 240, 240)',
    boxSizing: 'border-box',
    borderBottom: '1px solid grey',
    borderLeft: '1px solid grey',
    borderRight: '1px solid grey',
    borderRadius: '0 0 2px 2px',
  },
  checkbox: {
    width: 'unset',
  },
  labelStyles: {
    width: 'fit-content',
    fontWeight: 'normal',
    fontSize: '14px',
  },
}



// WEBPACK FOOTER //
// ./src/components/Settings/MessageSettingApptTypePicker/styles.js